export default "__VITE_ASSET__d862774c__"